import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

interface UseCopyToClipboardOptions {
  timeout?: number;
  onSuccess?: () => void;
}

export function useCopyToClipboard(options?: UseCopyToClipboardOptions) {
  const { timeout = 2000, onSuccess } = options ?? {};
  const [copied, setCopied] = useState(false);

  const copy = useCallback(
    async (value: string) => {
      try {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        onSuccess?.();
      } catch {
        setCopied(false);
        toast.error("Failed to copy to clipboard");
      }
    },
    [onSuccess],
  );

  useEffect(() => {
    if (!copied) return;

    const timeoutId = setTimeout(() => {
      setCopied(false);
    }, timeout);

    return () => clearTimeout(timeoutId);
  }, [copied, timeout]);

  return { copied, copy };
}
